import { Box, Stack, Typography } from '@dtx-company/design-system/src'
import { Check } from '@mui/icons-material'
import { FC } from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { SignupProps } from '../SignupPageContainer/SignupPageContainer.types'
import { authPromoPlanContent } from './AuthPromoSection.constants'
import { getPlanPromoContent } from './AuthPromoSection.utils'
import Image from 'next/image'

export const AuthPromoSection: FC<Pick<SignupProps, 'inviteState' | 'planTypeQueryParams'>> = ({
  inviteState,
  planTypeQueryParams
}) => {
  const planContent = getPlanPromoContent({ planTypeQueryParams })

  const inviteContent = inviteState?.inviteType ? authPromoPlanContent.accept_invite : undefined

  const displayContent = inviteContent || planContent || authPromoPlanContent.default

  return (
    <Stack sx={{ color: 'primary.contrastText' }}>
      <Typography variant="headlineSmall">
        Over 70% of Fortune 1000 companies trust Flowcode
      </Typography>

      <Box sx={theme => ({ mt: 8, minHeight: theme.spacing(30) })}>
        <List disablePadding dense>
          {displayContent.map(content => {
            return (
              <ListItem disableGutters key={content} sx={{ p: 0, mb: 4 }}>
                <ListItemIcon sx={theme => ({ minWidth: theme.spacing(8) })}>
                  <Check sx={{ color: 'upgrade.main' }} />
                </ListItemIcon>
                <ListItemText sx={{ m: 0 }}>{content}</ListItemText>
              </ListItem>
            )
          })}
        </List>
      </Box>

      <Box sx={theme => ({ maxWidth: theme.spacing(97.5), mt: 6 })}>
        <Image
          src={'/images/signup/brandsUsingFlowcode.png'}
          alt={'Brands using Flowcode'}
          width={390}
          height={36}
          style={{ width: '100%', height: 'auto' }}
        />
      </Box>
    </Stack>
  )
}
